import { Asterisk } from "lucide-react";

const ITEMS = [
  "SALEYES FIELD TRACKING",
  "YOUR EVERYDAY SMART AI",
  "AUTOMATED QUOTES",
  "REAL-TIME METRICS",
  "LIVE DISPATCH",
  "BUILT FOR MSME",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden bg-brand-red text-white py-4 border-y border-brand-redDark" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center shrink-0">
                <span className="font-display font-bold text-sm sm:text-base tracking-[0.15em] px-6">{item}</span>
                <Asterisk className="w-5 h-5 text-white/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
